export const SIDEBAR_WIDTH = {
  COLLAPSED: '88px',
  EXPANDED_SMALL: '220px',
  EXPANDED_LARGE: '240px',
} as const;

export const SIDEBAR_BREAKPOINT_WIDTH = 1440;
